import { useTheme } from 'styled-components';
import { BodyLoader, WalletUserBalanceWrapper, Amount, Change } from './styles';

export const WalletUserBalanceContentLoader = () => {
  const { colors } = useTheme();

  return (
    <WalletUserBalanceWrapper>
      <BodyLoader
        backgroundColor={colors.surface.interactiveDefault}
        foregroundColor={colors.surface.pressed}
      >
        <Amount />
        <Change />
      </BodyLoader>
    </WalletUserBalanceWrapper>
  );
};
